import { AxiosResponse } from 'axios';

export interface PagedRequest {
	'page.NumberOfItemsOnPage': number;
	'page.PageNumber': number;
	'order.OrderByAscending': boolean;
	'order.OrderColumn': string;
}

export interface ResultCollection<T> {
	totalCount: number;
	entities: T[];
}

export interface ResultSimplePagedCollection<T> {
	error: null | string;
	result: ResultCollection<T>;
}

export interface ResultData<T> {
	error: null | string;
	result: T | null;
}

export interface SuccessResponse {
	error: null | string;
	validationErrors?: {
		[key: string]: string[] | string;
	};
}

export enum FetchStatus {
	IDLE = 'idle',
	PENDING = 'pending',
	SUCCESS = 'success',
	FAILURE = 'failure',
}

export type AxiosTypedPromise<T> = Promise<AxiosResponse<T>>;
